import { parseBooleanValue } from "../../util";
import { IOrganisation } from "../model/Organisation";

const OrganisationParamMapper = (item: IOrganisation) => {
  return {
    ...item,
    valid: parseBooleanValue(item.valid)
  };
};

export default OrganisationParamMapper;
